<script>
import ValidationMixin from '../../mixins/validatorMixin';

export default {
  name: 'ItineraryAddCountryModal',
  data() {
    return {
      search: '',
      headers: [
        { text: this.$t('itinerary.countryModal.table.alias'), value: 'alias' },
        { text: this.$t('itinerary.countryModal.table.code'), value: 'code' },
      ],
      pagination: {
        rowsPerPage: 10,
        descending: false,
        sortBy: 'alias',
      },
      toggled: true,
      available: [],
      selected: [],
    };
  },
  props: {
    itineraryId: {
      type: Number,
      required: true,
    },
    availableCountries: {
      type: Array,
      default: () => [],
    },
    selectedCountries: {
      type: Array,
      default: () => [],
    },
    productTypes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    remove(event) {
      const selected = [...this.selected];
      const available = [...this.available];
      const country = selected.splice(event, 1);
      available.push(country[0]);
      this.available = available;
      this.selected = selected;
    },
    add(event) {
      const selected = [...this.selected];
      const available = [...this.available];
      const index = this.available.findIndex(item => item.id === event.id);
      selected.push(event);
      available.splice(index, 1);
      this.available = available;
      this.selected = selected;
    },
    update() {
      this.$emit('update', { itineraryId: this.itineraryId, countryIds: this.selected.map(country => country.id) });
    },
  },
  created() {
    this.available = this.availableCountries;
    this.selected = this.selectedCountries;
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
  },
  mixins: [ValidationMixin],
};
</script>

<template>
  <v-dialog
    max-width="800px"
    v-model="toggled">
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>edit</v-icon>
        {{ $t('itinerary.countryModal.title') }}
      </v-flex>
      <v-divider light/>
      <v-layout row wrap>
        <v-flex v-if="selected.length" sm12 pa-3>
          <v-chip
            v-for="(country, index) in selected"
            :key="`selected-countries__${index}`"
            close
            color="teal"
            text-color="white"
            @input="remove(index)">
            <span>
              <strong>{{ country.alias }}</strong>
            </span>
          </v-chip>
        </v-flex>
        <v-flex v-else sm12 pa-3 text-xs-center class="no-countries">
          <i>{{ $t('itinerary.countryModal.noCountries') }}</i>
        </v-flex>
        <v-flex sm12>
          <v-text-field
            v-model="search"
            class="px-4"
            clearable
            clear-icon="clear"
            append-icon="search"
            :loading="loading"
            :label="$t('inputs.placeholders.search')"/>
        </v-flex>
        <v-flex sm12>
          <v-data-table
            class="elevation-1"
            item-key="id"
            :headers="headers"
            :items="available"
            :pagination.sync="pagination"
            :loading="loading"
            :search="search"
            :no-data-text="$t('itinerary.countryModal.noData')">
            <template v-slot:items="props">
              <tr
                class="table-row"
                @click="add(props.item)">
                <td>{{ props.item.alias }}</td>
                <td>{{ props.item.code }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false">
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          :disabled="availableCountries === available || loading"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update">
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<style>
  .table-row {
    cursor: pointer;
  }
  .no-countries {
    color: #a6a6a6;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryAddCountryModal.vue